export interface ContextType {
    name: string;
    icon?: string;
}
